import { render } from "./DataTitle.vue?vue&type=template&id=2a9a808c"
import script from "./DataTitle.vue?vue&type=script&lang=js"
export * from "./DataTitle.vue?vue&type=script&lang=js"
script.render = render

export default script